import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import store from './store'
import router from './router'
import { createAxiosPlugin } from './plugins/axios'
import 'filters'
import BigNumber from 'bignumber.js'
import echarts from 'echarts'
import SvgIcon from 'vue-svgicon'
import '@/assets/icons'

// eslint-disable-next-line no-console
console.info('[frontend-lvbit-saas] build config', {
  env: process.env.VUE_APP_ENV || process.env.NODE_ENV,
  api: process.env.VUE_APP_API_PROXY_FUTURES_URL,
})

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(createAxiosPlugin())
Vue.prototype.BigNumber = BigNumber
Vue.prototype.$echarts = echarts

Vue.use(SvgIcon, {
  tagName: 'svgicon',
})

// eslint-disable-next-line
Vue.config.productionTip = process.env.NODE_ENV === 'production'
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app')
